import { render, staticRenderFns } from "./jkfillgl.vue?vue&type=template&id=18d87fb5&scoped=true&"
import script from "./jkfillgl.vue?vue&type=script&lang=js&"
export * from "./jkfillgl.vue?vue&type=script&lang=js&"
import style0 from "./jkfillgl.vue?vue&type=style&index=0&id=18d87fb5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d87fb5",
  null
  
)

export default component.exports